import React from 'react';
import { DialogV2 } from '@withjoy/joykit';
import { PayoutAccountInfo } from './CreditCardSetUp.context';
import { Introduction } from './steps/Introduction';
import { OnboardingStatus } from './steps/OnboardingStatus';
import { ReadyToUse } from './steps/ReadyToUse';
import { pxToRem } from '@withjoy/joykit/theme';

type CreditCardSetupInitiatorDialogProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  isOwner: boolean;
  payoutAccountInfo?: PayoutAccountInfo | null;
  initKYCOnboarding: () => void;
  initPayoutAccountLoading: boolean;
  maxAttemptsReached: boolean;
  isValidUSAddress: boolean;
  shouldSkipAddressValidation: boolean;
  handleInvalidShippingAddress?: () => void;
}>;
export const CreditCardSetupInitiatorDialog: React.FC<CreditCardSetupInitiatorDialogProps> = ({
  isOpen,
  onClose,
  isOwner,
  payoutAccountInfo,
  initKYCOnboarding,
  initPayoutAccountLoading,
  maxAttemptsReached,
  isValidUSAddress,
  shouldSkipAddressValidation,
  handleInvalidShippingAddress,
}) => {
  return (
    <DialogV2
      onClose={onClose}
      isOpen={isOpen}
      overrides={{
        Content: {
          props: {
            width: pxToRem(768),
          },
        },
      }}
    >
      <DialogV2.CloseButton />
      {(!payoutAccountInfo || (payoutAccountInfo.status !== 'pending' && payoutAccountInfo.status !== 'readyToUse')) && (
        <Introduction
          payoutAccountInfo={payoutAccountInfo}
          initKYCOnboarding={initKYCOnboarding}
          isOwner={isOwner}
          initPayoutAccountLoading={initPayoutAccountLoading}
          isValidUSAddress={isValidUSAddress}
          shouldSkipAddressValidation={shouldSkipAddressValidation}
          handleInvalidShippingAddress={handleInvalidShippingAddress}
        />
      )}
      {payoutAccountInfo && payoutAccountInfo.status === 'pending' && (
        <OnboardingStatus
          onboardingUrl={payoutAccountInfo.onboardingUrl}
          maxAttemptsReached={maxAttemptsReached}
          status={payoutAccountInfo.status}
        />
      )}
      {payoutAccountInfo && payoutAccountInfo.status === 'readyToUse' && <ReadyToUse onClose={onClose} />}
    </DialogV2>
  );
};
